
import React from 'react';
import { withRouter } from "react-router-dom";
import Navhome from '../components/navbarhome';
import '../components/home.css';

import './ribbon.css';
import Imagecomparison from '../components/imagecomparison';

import {connect} from 'react-redux';

// import './stripex.js';
import pop from '../components/full.webp';

import tc from '../images/tc.png'
// import trans from './home-translate-all.png'
// import p1 from '../images/addtext.png'
import f1 from '../images/f1.png'
import f2 from '../images/f2.png'
import f3 from '../images/f3.png'
import f4 from '../images/resize.png'
import f5 from '../images/f5.png'
// import popd from '../components/full.jpeg';
// import popx from './pop1.png';




import { navigate } from "gatsby"  
import { increment, update_x, edit_boxes, pop_boxes, invalidate, selectedText, render_x, decrement, reset } from "../actions/sampleAction";


import AcUnitIcon from '@material-ui/icons/AcUnit';

import Signin from './signin';


class Home extends React.Component {
  constructor(props) {
    super(props);

    console.log('history',props)

    this.state = {
      imageURL: '',
      videoname: '',
      fileprogess:null,
      isOpen: false,
      dataLoaded: false,
      isFormInvalid: false,
      rows: null,
      cols: null
    };

    // this.handleUploadImage = this.handleUploadImage.bind(this);
    // this.cutClip = this.cutClip.bind(this);

    this.fileInput = React.createRef();

  }



componentDidMount() {

      // document.title = 'TurtleClip | Add subtitles & text to Video for Free';


        document.getElementById('login3').addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();


            document.getElementById('signx').style.display = 'block'


});

var TxtRotate = function(el, toRotate, period) {
    this.toRotate = toRotate;
    this.el = el;
    this.loopNum = 0;
    this.period = parseInt(period, 10) || 2000;
    this.txt = '';
    this.tick();
    this.isDeleting = false;
  };
  
  TxtRotate.prototype.tick = function() {
    var i = this.loopNum % this.toRotate.length;
    var fullTxt = ' ' + this.toRotate[i];
  
    if (this.isDeleting) {
      this.txt = fullTxt.substring(0, this.txt.length - 1);
    } else {
      this.txt = fullTxt.substring(0, this.txt.length + 1);
    }
  
    this.el.innerHTML = '<span class="wrap">'+this.txt+'</span>';
  
    var that = this;
    var delta = 300 - Math.random() * 100;
  
    if (this.isDeleting) { delta /= 2; }
  
    if (!this.isDeleting && this.txt === fullTxt) {
      delta = this.period;
      this.isDeleting = true;
    } else if (this.isDeleting && this.txt === '') {
      this.isDeleting = false;
      this.loopNum++;
      delta = 300;
    }
  
    setTimeout(function() {
      that.tick();
    }, delta);
  };
  
  // window.onload = function() {
    var elements = document.getElementsByClassName('txt-rotate');
    for (var i=0; i<elements.length; i++) {
      var toRotate = elements[i].getAttribute('data-rotate');
      var period = elements[i].getAttribute('data-period');
      if (toRotate) {
        new TxtRotate(elements[i], JSON.parse(toRotate), period);
      }
    }
    // INJECT CSS
    var css = document.createElement("style");
    css.type = "text/css";
    css.innerHTML = ".txt-rotate > .wrap { border-right: 0.08em solid #666 }";
    document.body.appendChild(css);
  // };




// if user already signed in
      var user_id = localStorage.getItem('uid')
      
      if (user_id) {

        var d = {}
        d['uid'] = user_id

// tryinggg
        // navigate(`/vidx/?v=${user_id}`, 
        // { state: { vid: d }} )

        // navigate('/workspace/');

        // navigate(`/workspace/${user_id}`, 
        //   {state: { videos: d }} )

        navigate(`/workspace/?w=${user_id}`, 
          {state: { videos: d }} )

    //     this.props.history.push({
    //       pathname: `/workspace/${user_id}`
    //       ,
    //       state: { videos: d }
    // })

// if there is no uid - there should be no info on subscribe, pic, email
      } else {
        localStorage.removeItem('cn')
        localStorage.removeItem('pic')
        localStorage.removeItem('email')
      }



}

// // export default withRouter(Home);
// <Imagecomparison />   // 
                        
  render() {
    return (
      <div style={{'background-color': 'rgba(249,250,251,1)' }}>
      <Navhome props={this.props} />

<Signin props={this.props} />

<div className="splitscreen">

  <div className="split1">
    <div style={{'marginTop': '7vw'}}>
    <h1> Make Your Videos Stand Out  
    </h1>


<h2 className="didyou">Did you know that 85% of social media videos are played on mute?
</h2>



<div className='jumbo-2'> 
<h3>
Add <div className='dummy_icon' /> Auto-generated Subtitles <div className='dummy_icon' /> Auto-translated Captions <div className='dummy_icon' /> Text <div className='dummy_icon' /> Heading <div className='dummy_icon' /> Progress bar <div className='dummy_icon' /> Resize  
</h3>          
</div>    



    <h4>
    Translate video to English, Spanish, German, Indonesian, Russian, Chinese, Korean, Portuguese and more than 60 languages in minutes.
    </h4>


    </div>
    
    <div className="no_accnt">Free Trial. No credit card required</div> 
    
    <br />
<div id="login3" className="signup3">Get Started for Free</div>
  </div>

   

<img className="home_ful" srcset={tc} type="image/webp" alt="Add auto-generated subtitles in minutes" />
  

</div> 
  
<div id="tweets_">


<div style={{'display': 'flex', 'flex-direction': 'column' }}>

<blockquote class="twitter-tweet"><p lang="en" dir="ltr">Easiest way to boost your video content:<br/><br/>Add. Subtitles.</p>&mdash; Shama Hyder (@Shama) <a href="https://twitter.com/Shama/status/1422622544100831241?ref_src=twsrc%5Etfw">August 3, 2021</a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script> 


<blockquote class="twitter-tweet"><p lang="en" dir="ltr">80% of consumers say they are more likely to watch a video to completion if there are captions.<br/><br/>Add subtitles to your videos.</p>&mdash; Johnluke Nahorski (@jlnahorski) <a href="https://twitter.com/jlnahorski/status/1424353404130893827?ref_src=twsrc%5Etfw">August 8, 2021</a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script> 

</div>

<blockquote class="twitter-tweet" data-conversation="none" data-theme="light"><p lang="en" dir="ltr">Add subtitles to your video ads.<br /><br />According to <a href="https://twitter.com/verizonmedia?ref_src=twsrc%5Etfw">@verizonmedia</a>, 92% of mobile users watch videos with sound off. 🔇<br /><br />Adding 20 minutes to your video editing time will achieve higher:<br /><br />• click-through rate<br />• website conversion rate<br />• return on ad spend (ROAS)</p>&mdash; Nik Sharma (@mrsharma) <a href="https://twitter.com/mrsharma/status/1406735675592871937?ref_src=twsrc%5Etfw">June 20, 2021</a></blockquote> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script> 

</div>

  <div className="home_text_2">Producing content takes sweat. But if you are spending all your resources marketing it in your native language only, you are missing out on large set of potential customers. 55% of consumers prefer to make purchases in their native languages. People who don't speak your language, and would prefer consuming content in their local languages like French, Spanish, Portuguese, Chinese, Hindi, Indonesian, Italian etc are less likely to buy in your language content. 
  </div>


  <img className="home_full" srcset={pop} type="image/webp" alt="Add auto-generated subtitles in minutes" />


<div style={{'display':'flex', 'flex-direction':'column'}} >

<div style={{'display': 'flex'}}>

  <div className="home_text_2">85% of users prefer watching content on mute. Remember, those loo breaks, or lunch breaks watching videos on silent. If there is no subtitles you are likely gonna move onto next video. Adding transcription will significantly reduce video drop offs and improve engagement.
  </div>
</div>

    

  <div className="uses">


        <img className="f" srcset={f1} type="image/png" alt="Add subtitles in 30+ languages, translate to 60+ languages" />
        
        <div className='ft'>
          <div className='fft'> Auto subtitle </div>
          <div>Once you uplaod a video, subtitles are automatically generated using AI. 85% users watch videos on mute. Adding subtitles will result in users watching full video. Subtitles can be generated in multiple different languages. </div>
        </div>

  </div>



  <div className="uses">

        <div className='ft'>
          <div className='fft'> Add & Style Text </div>
          <div>Add Heading on top of video, and style it. Put multiple texts anywhere on your video. You can edit, style and position the subtitles in minutes</div>
        </div>

        <img className="f" srcset={f2} type="image/png" alt="Add Text & Heading" />
        
  </div>



  <div className="uses">

        <img className="f" srcset={f3} type="image/png" alt="Add Progress Bar" />

        <div className='ft'>
          <div className='fft'> Add Progress Bar </div>
          <div>A progress bar will be automatically added to the video.</div>
        </div>

  </div>


  <div className="uses">

        <div className='ft'>
          <div className='fft'> Resize Video </div>
          <div>You can resize the video to 1:1, 9:16, 16:9, 4:5 dimensions suited for different social media platforms easily.</div>
        </div>

        <img className="f" srcset={f4} type="image/png" alt="Resize Video" />
        
  </div>


    <div className="uses">

        <img className="f" srcset={f5} type="image/png" alt="Translate Video" />
        

        <div className='ft'>
          <div className='fft'> Translate Video Subtitles</div>
          <div>Auto translate video to more than 60 languages, in minutes</div>
        </div>

        
  </div>

</div>





        
      
      </div>
    );
  }
}


const mapStateToProps = (state) => {
  console.log('!!!mapStateToProps', state)
  return {
  boxes2: state.data.boxes2,
  canvasValid: state.data.canvasValid,
  selectText: state.data.selectText,

  xout: state.data.xout,
  width: state.data.width,
  height: state.data.height,
  pc: state.data.pc,
  back_bar: state.data.back_bar, 
  front_bar: state.data.front_bar,
  bar_height: state.data.bar_height,
  duration: state.data.duration,
  dvid: state.data.dvid,
  pre_sub: state.data.pre_sub,
  ti: state.data.ti,

  render: state.data.render,
  subscribe: state.data.subscribe,
  uid: state.data.uid,
  email: state.data.email,
  pic: state.data.pic,
  filename: state.data.filename,
  
}}


Home.displayName = "Home";
export default connect(mapStateToProps, { increment, update_x, edit_boxes, pop_boxes, invalidate, selectedText, render_x, decrement, reset })(React.memo(Home));


